import React from 'react';
import { Facebook, Instagram, ExternalLink } from 'lucide-react';
import { companyInfo, socialLinks } from '../mock';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4 flex flex-col items-center md:items-start">
            <img 
              src={companyInfo.logo} 
              alt="Greenwood Property Group" 
              className="h-20 w-auto"
            />
            <p className="text-gray-400 leading-relaxed text-center md:text-left">
              Your trusted partner in property services and real estate solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('property-services')}
                  className="hover:text-amber-400 transition-colors"
                >
                  Property Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('real-estate')}
                  className="hover:text-amber-400 transition-colors"
                >
                  Real Estate
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('cabin-rentals')}
                  className="hover:text-amber-400 transition-colors"
                >
                  Cabin Rentals
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-amber-400 transition-colors"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Our Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">Property Management</li>
              <li className="text-gray-400">Painting & Tiling</li>
              <li className="text-gray-400">Lawn Care & Cleaning</li>
              <li className="text-gray-400">Real Estate Sales</li>
              <li className="text-gray-400">Rental Management</li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Connect With Us</h4>
            
            {/* Property Group Social */}
            <div className="mb-4">
              <p className="text-sm text-gray-400 mb-2">Property Group</p>
              <div className="flex space-x-3">
                <a 
                  href={socialLinks.propertyGroup.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-700 transition-colors"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a 
                  href={socialLinks.propertyGroup.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-700 transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Real Estate Social */}
            <div className="mb-4">
              <p className="text-sm text-gray-400 mb-2">Real Estate</p>
              <div className="flex space-x-3">
                <a 
                  href={socialLinks.realEstate.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-stone-600 transition-colors"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a 
                  href={socialLinks.realEstate.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-stone-600 transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a 
                  href={socialLinks.realEstate.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-stone-600 transition-colors"
                >
                  <ExternalLink className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Tiling Social */}
            <div>
              <p className="text-sm text-gray-400 mb-2">Top Notch Tile</p>
              <div className="flex space-x-3">
                <a 
                  href={socialLinks.tiling.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-700 transition-colors"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a 
                  href={socialLinks.tiling.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-700 transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
